import React from 'react'
import {Link} from 'react-router-dom'
import qs from 'query-string'
import PropTypes from 'prop-types'

const Order = ({action, type, pool, restaurant, sortField, sortDirection}) => {
  if (sortDirection !== null) {
    let icon = "fa fa-sort-" + type + "-" + sortDirection
    let reverseDirection = sortDirection === 'asc' ? 'desc' : 'asc'

    let params =  qs.stringify({pool:pool, restaurant: restaurant, sortField:sortField, page:1, sortDirection:reverseDirection})

    let link = '/pools?' + params
    return <Link to={link}><span className={icon} /></Link>
  }

  let params =  qs.stringify({pool:pool, restaurant: restaurant, sortField:sortField, page:1, sortDirection:'asc'})
  let link = '/pools?' + params
  return <Link to={link}><span className="fa fa-sort" /></Link>
}

export default Order

Order.propTypes = {
  action: PropTypes.string,
  type: PropTypes.string.isRequired,
  pool: PropTypes.string,
  restaurant: PropTypes.string,
  sortField: PropTypes.string.isRequired,
  sortDirection: PropTypes.string
}


// WEBPACK FOOTER //
// ./src/containers/pools/index/order.js